import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Gift } from 'lucide-react';
import { BONUSES } from '../data/bonuses';
export function BonusStack() {
  return <section className="py-9 md:py-16 bg-clinical-mist" data-id="element-14" data-mp="2khtk77xtdkk">
      <div className="max-w-[1140px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15" data-mp="2kzngx74nfpb">
        <div className="text-center max-w-2xl mx-auto mb-5 md:mb-9" data-id="element-16" data-mp="6mcuhalyhoxt">
          <p className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-2" data-id="element-17" data-mp="3616rj4tgfeym">
            Bonos incluidos
          </p>
          <h2 className="text-[1.35rem] sm:text-3xl md:text-4xl font-black text-clinical-deep mb-2 leading-[1.1] uppercase" data-id="element-18" data-mp="3b12sswarosah">
            5 bonos{' '}
            <span className="accent-italic normal-case" data-id="element-19" data-mp="3jscwvhjf06tf">estratégicos</span>
          </h2>
          <p className="text-[14px] md:text-base text-clinical-ink leading-snug" data-id="element-20" data-mp="2nap156w3gvgf">
            Guías de bolsillo digitales para consultar desde el celular{' '}
            <span className="font-bold text-clinical-deep" data-id="element-21" data-mp="2rar3li9nlswr">en 30 segundos</span>
            , en plena práctica.
          </p>
        </div>

        <ul className="grid grid-cols-2 lg:grid-cols-5 gap-2.5 md:gap-4 mb-5 md:mb-8" data-id="element-22" data-mp="3nbqhj0d6hy4v">
          {BONUSES.map((bonus, idx) => <motion.li key={bonus.title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          delay: Math.min(idx * 0.04, 0.16),
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col overflow-hidden rounded-xl bg-white border border-clinical-line/80 shadow-[0_4px_14px_rgba(11,42,74,0.07)]" data-id="element-23" data-mp="3ik8fe8zf5rib" data-mpi={idx}>
              <div className="relative w-full overflow-hidden bg-clinical-mist aspect-[4/5] sm:aspect-[3/4]" data-id="element-24" data-mp="svy3u6ioa45x">
                <img src={bonus.cover} alt={bonus.title} width={600} height={800} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-contain" data-id="element-25" data-mp="2nbdbw6pee3s4" />
              </div>

              <div className="flex flex-1 flex-col px-2.5 py-2.5 md:px-3.5 md:py-3" data-id="element-26" data-mp="2idboj9kxviau">
                <p className="text-[9px] md:text-[10px] font-bold tracking-[0.16em] uppercase text-clinical-mid mb-0.5" data-id="element-27" data-mp="363pm1fmam9ct">
                  Bono {idx + 1}
                </p>
                <h3 className="text-[11.5px] md:text-[12.5px] font-black text-clinical-deep leading-tight uppercase tracking-wide mb-0.5" data-id="element-28" data-mp="2w4qb1qe221mn">
                  {bonus.title}
                </h3>
                <p className="text-[11.5px] md:text-[12.5px] text-clinical-ink/90 leading-snug" data-id="element-29" data-mp="1kojts7xp8ygk">
                  {bonus.desc}
                </p>
              </div>
            </motion.li>)}
        </ul>

        <div className="flex flex-col items-center gap-3.5" data-id="element-30" data-mp="7pqbhnv2vne6">
          <p className="inline-flex items-center gap-2 rounded-full bg-clinical-deep px-4 py-2 text-[10.5px] sm:text-xs font-bold uppercase tracking-[0.14em] text-clinical-accent text-center" data-id="element-31" data-mp="7scgbfql3osp">
            <Gift size={13} strokeWidth={2.4} className="flex-shrink-0" data-id="element-32" data-mp="gov8gpqzr8o8" />
            Incluidos gratis · Siempre en tu celular
          </p>

          <a href="#pricing" className="group inline-flex items-center justify-center gap-2 bg-clinical-cta hover:bg-clinical-ctaHover text-white font-bold text-sm md:text-base px-7 md:px-9 py-4 rounded-full transition-[transform,background-color] duration-200 ease-out hover:scale-[1.02] active:scale-[0.98] shadow-[0_10px_28px_rgba(15,98,254,0.32)] w-full max-w-[380px] sm:w-auto uppercase tracking-[0.03em] text-center" data-id="element-33" data-mp="3l4mpn23282t6">
            Quiero acceder a Atlas Clínico
            <ArrowRight size={17} className="transition-transform duration-200 ease-out group-hover:translate-x-1 flex-shrink-0" data-id="element-34" data-mp="2xesbmh70887c" />
          </a>
        </div>
      </div>
    </section>;
}